import React, { useState } from 'react';
import icon from '../assets/pad-pro-contact-us.png';
import trainingImage1 from '../assets/training/training-image-1.jpg';
import trainingImage2 from '../assets/training/training-image-2.jpg';
import trainingImage3 from '../assets/training/training-image-3.jpg';
import trainingImage4 from '../assets/training/training-image-4.jpg';
import trainingImage5 from '../assets/training/training-image-5.jpg';
import trainingImage6 from '../assets/training/training-image-6.jpg';

export default function EventsSectionA() {
  const [lightbox, setLightbox] = useState(null);

  const showPrevImage = (e) => {
    e.stopPropagation();
    setLightbox((prev) =>
      prev && { ...prev, index: (prev.index - 1 + prev.images.length) % prev.images.length }
    );
  };

  const showNextImage = (e) => {
    e.stopPropagation();
    setLightbox((prev) =>
      prev && { ...prev, index: (prev.index + 1) % prev.images.length }
    );
  };

  const photoGalleryEvents = [
    {
      id: 1,
      title: "RBT Training 2026",
      description: "Highlights from our RBT Training, a hands-on session focused on building staff confidence and Individual independence within our PADPRO community.",
      date: "2026",
      category: "Training",
      images: [
        trainingImage1,
        trainingImage2,
        trainingImage3,
        trainingImage4,
        trainingImage5,
        trainingImage6,
      ],
    },
  ];

  const events = [
    {
      id: 1,
      title: "PADPRO Christmas Party 2025",
      description: "Join us for a festive celebration with our PADPRO community! A compilation of memorable moments from our Christmas Party featuring activities, performances, and holiday cheer.",
      videoUrl: "https://www.youtube.com/watch?v=39bbF9mXFWE",
      thumbnail: "https://i.ytimg.com/an_webp/WhyZtxe_gXw/mqdefault_6s.webp?du=3000&sqp=CLDT9csG&rs=AOn4CLC4mSUOZ1m_7qsTFjzTkCKQ6TLIHw",
      date: "December 2025",
      duration: "1:53:22",
      category: "Community Event"
    },
    {
      id: 2,
      title: "PADPRO Station ID 2025",
      description: "Our official Station ID showcasing the heart of PADPRO and the wonderful people who make our community special.",
      videoUrl: "https://www.youtube.com/watch?v=dUQ4tlvb0p4",
      thumbnail: "https://i.ytimg.com/an_webp/dUQ4tlvb0p4/mqdefault_6s.webp?du=3000&sqp=CP629csG&rs=AOn4CLBPjpir35OEr-fr3YOZi26Bsh3Dng",
      date: "January 2025",
      duration: "9:01",
      category: "Station ID"
    },
    {
      id: 3,
      title: "Padpro Xmas Party 2024",
      description: "Relive the magical moments from our 2024 Christmas celebration with music, dance, and community spirit.",
      videoUrl: "https://www.youtube.com/watch?v=ycZtcComb24",
      thumbnail: "https://i.ytimg.com/an_webp/ycZtcComb24/mqdefault_6s.webp?du=3000&sqp=CKTi9csG&rs=AOn4CLCg8KwIxGEqexvyvzynSVTQRZYIcw",
      date: "December 2024",
      duration: "3:46",
      category: "Community Event"
    },
  ];

  const upcomingEvents = [
    {
      title: "PADPRO Sportsfest",
      description: "An exciting day of athletic competitions and team sports celebrating fitness, sportsmanship, and healthy competition. Participants engage in various sporting activities, games, and challenges while promoting active lifestyles and community spirit."
    },
    {
      title: "Halloween Party",
      description: "A festive celebration filled with costumes, decorations, games, and treats. Join us for a spooktacular event featuring creative costume contests, themed activities, music, dancing, and plenty of Halloween fun for all participants."
    },
    {
      title: "Thanksgiving Celebration",
      description: "A heartwarming gathering to express gratitude and share the spirit of thanksgiving. Features a traditional feast, community fellowship, and special activities that bring everyone together to celebrate blessings and create cherished memories."
    },
  ];

  const handleWatchVideo = (videoUrl) => {
    window.open(videoUrl, '_blank');
  };

  return (
    <div>
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            className="w-full h-full object-cover"
            src={icon}
            alt="Events hero background"
          />
          <div className="absolute inset-0 bg-black/20"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 md:py-20 lg:py-24">
          <div className="max-w-3xl">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white mb-4 sm:mb-6 newsreader font-bold">
              Events
            </h1>
            <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-white mb-3 sm:mb-4 newsreader">
              Celebrating Community & Connection
            </h2>
            <p className="text-base sm:text-lg text-white/95 mb-2 newsreader leading-relaxed">
              Explore our vibrant community events, activities, and special moments that bring us together.
            </p>
            <p className="text-base sm:text-lg text-white/95 newsreader leading-relaxed">
              From celebrations to wellness activities, discover what makes PADPRO special.
            </p>
          </div>
        </div>
      </div>

      {/* Featured Events Section */}
      <div className="bg-white py-8 sm:py-12 md:py-16 lg:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 newsreader">
              Featured Events & Activities
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto newsreader">
              Watch our latest videos and relive the best moments from PADPRO events
            </p>
          </div>

          {/* Event Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {events.map((event, index) => (
              <div 
                key={event.id}
                data-aos="fade-up" 
                data-aos-duration="1000"
                data-aos-delay={index * 100}
                className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 group"
              >
                {/* Video Thumbnail */}
                <div className="relative aspect-video bg-gray-200 overflow-hidden cursor-pointer"
                     onClick={() => handleWatchVideo(event.videoUrl)}>
                  <img 
                    src={event.thumbnail}
                    alt={event.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    onError={(e) => {
                      e.target.src = icon; // Fallback image
                    }}
                  />
                  <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-colors duration-300 flex items-center justify-center">
                    <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <svg className="w-8 h-8 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M8 5v14l11-7z"/>
                      </svg>
                    </div>
                  </div>
                  {/* Duration Badge */}
                  <div className="absolute bottom-2 right-2 bg-black/80 text-white px-2 py-1 rounded text-xs font-semibold">
                    {event.duration}
                  </div>
                  {/* Category Badge */}
                  <div className="absolute top-2 left-2 bg-green-500 text-white px-3 py-1 rounded-full text-xs font-semibold">
                    {event.category}
                  </div>
                </div>

                {/* Event Details */}
                <div className="p-4 sm:p-6">
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 newsreader group-hover:text-green-600 transition-colors duration-300">
                    {event.title}
                  </h3>
                  <p className="text-sm text-gray-500 mb-3 flex items-center gap-2">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    {event.date}
                  </p>
                  <p className="text-sm sm:text-base text-gray-600 mb-4 newsreader leading-relaxed">
                    {event.description}
                  </p>
                  <button 
                    onClick={() => handleWatchVideo(event.videoUrl)}
                    className="w-full bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded-md transition-colors duration-300 flex items-center justify-center gap-2"
                  >
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M8 5v14l11-7z"/>
                    </svg>
                    Watch Video
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Photo Gallery Section */}
      <div className="bg-gray-50 py-8 sm:py-12 md:py-16 lg:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 newsreader">
              Photo Gallery
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto newsreader">
              A look back at photos from our recent community activities
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {photoGalleryEvents.map((event, index) => (
              <div
                key={event.id}
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-delay={index * 100}
                className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 group"
              >
                {/* Image Grid */}
                <div className="relative aspect-video bg-gray-200 overflow-hidden">
                  <div className="grid grid-cols-3 grid-rows-2 gap-0.5 w-full h-full">
                    {event.images.slice(0, 6).map((image, imgIndex) => (
                      <div
                        key={imgIndex}
                        className="relative overflow-hidden cursor-pointer"
                        onClick={() => setLightbox({ images: event.images, index: imgIndex })}
                      >
                        <img
                          src={image}
                          alt={`${event.title} ${imgIndex + 1}`}
                          className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                        />
                      </div>
                    ))}
                  </div>
                  {/* Photo Count Badge */}
                  <div className="absolute bottom-2 right-2 bg-black/80 text-white px-2 py-1 rounded text-xs font-semibold pointer-events-none">
                    {event.images.length} Photos
                  </div>
                  {/* Category Badge */}
                  <div className="absolute top-2 left-2 bg-green-500 text-white px-3 py-1 rounded-full text-xs font-semibold pointer-events-none">
                    {event.category}
                  </div>
                </div>

                {/* Event Details */}
                <div className="p-4 sm:p-6">
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 newsreader group-hover:text-green-600 transition-colors duration-300">
                    {event.title}
                  </h3>
                  <p className="text-sm text-gray-500 mb-3 flex items-center gap-2">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    {event.date}
                  </p>
                  <p className="text-sm sm:text-base text-gray-600 newsreader leading-relaxed">
                    {event.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Upcoming Events Section */}
      <div className="bg-white py-8 sm:py-12 md:py-16 lg:py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 newsreader">
              Upcoming Events
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto newsreader">
              Mark your calendars! Join us for these exciting upcoming events
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {upcomingEvents.map((event, index) => (
              <div 
                key={index}
                data-aos="fade-up" 
                data-aos-duration="1000"
                data-aos-delay={index * 100}
                className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-300"
              >
                <div className="flex items-start gap-4 mb-4">
                  <div className="bg-green-500 rounded-lg p-3 flex-shrink-0">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 newsreader">
                      {event.title}
                    </h3>
                  </div>
                </div>
                <p className="text-sm sm:text-base text-gray-600 newsreader leading-relaxed">
                  {event.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Contact CTA Section */}
      <div className="bg-gradient-to-r from-green-500 to-green-600 py-8 sm:py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 newsreader">
            Want to Join Our Events?
          </h2>
          <p className="text-base sm:text-lg text-white/95 mb-6 max-w-2xl mx-auto newsreader">
            Contact us to learn more about participating in our activities and becoming part of the PADPRO community.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a 
              href="mailto:padproadult@yahoo.com"
              className="bg-white text-green-600 hover:bg-gray-100 font-semibold py-3 px-8 rounded-md transition-colors duration-300 flex items-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              Email Us
            </a>
            <a 
              href="tel:+14083470402"
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-green-600 font-semibold py-3 px-8 rounded-md transition-colors duration-300 flex items-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              Call Us
            </a>
          </div>
        </div>
      </div>

      {/* Image Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-4 right-4 sm:top-6 sm:right-6 text-white bg-black/50 hover:bg-black/70 rounded-full p-2 transition-colors duration-300"
            onClick={() => setLightbox(null)}
            aria-label="Close"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <button
            className="absolute left-2 sm:left-6 top-1/2 -translate-y-1/2 text-white bg-black/50 hover:bg-black/70 rounded-full p-2 transition-colors duration-300"
            onClick={showPrevImage}
            aria-label="Previous photo"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          <img
            src={lightbox.images[lightbox.index]}
            alt="Enlarged view"
            className="max-w-full max-h-full object-contain rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />

          <button
            className="absolute right-2 sm:right-6 top-1/2 -translate-y-1/2 text-white bg-black/50 hover:bg-black/70 rounded-full p-2 transition-colors duration-300"
            onClick={showNextImage}
            aria-label="Next photo"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
}